<template>
    <ul class="cic-container">
        <li class="cic-header">
            <span class="cic-header-title">{{ title }}</span>
            <span
                v-if="addButton !== ''"
                id="add_button"
                :title="addButton"
                class="cic-header-add"
                @click="$emit('input', -1)"
            >
            </span>
            <icon-button v-if="helpText" icon="help-icon" :title="helpText" />
        </li>
        <li>
            <slot></slot>
        </li>
        <li class="cic-footer">
            <cic-page-control :page="page" :total-rows="totalRows" @change="(val) => $emit('change', val)" />
            <cic-button v-if="deleteButton" id="delete_button" @click="deleteItems">
                {{ $t('Delete selected') }}
            </cic-button>
            <slot name="footer"></slot>
        </li>
    </ul>
</template>

<script>
    import CicButton from '@/components/CicButton';
    import CicPageControl from '@/components/CicPageControl';
    import IconButton from '@/components/controls/IconButton';

    export default {
        name: 'Panel',
        components: {
            IconButton,
            CicPageControl,
            CicButton,
        },
        props: {
            addButton: {
                type: String,
                default: '',
            },
            deleteButton: {
                type: Boolean,
                default: false,
            },
            deleteWarningText: {
                type: String,
                default: null,
            },
            helpText: {
                type: String,
                default: '',
            },
            page: {
                type: Number,
                default: 1,
            },
            title: {
                type: String,
                default: '',
            },
            totalRows: {
                type: Number,
                default: 0,
            },
        },
        emits: ['change', 'delete', 'input'],
        methods: {
            deleteItems() {
                if (confirm(this.deleteWarningText ?? this.$t('DELETE_MULTIPLE_CONFIRM'))) {
                    this.$emit('delete');
                }
            },
        },
    };
</script>
